<template>
  <div class="class_fly">
    <!-- 顶部搜索 -->
    <div class="top_index">
      <div class="heigth"></div>
      <div class="search">
        <input
          type="text"
          placeholder="请输入您要找的商品"
          v-model="searchName"
          @keypress="searchInputConHandler"
        />
        <a href="javascript:;" @click="searchFg">搜索</a>
      </div>
    </div>
    <!-- 商品列表 -->
    <div class="goods_list">
      <van-sticky>
        <!-- icon_xa.png -->
        <div class="tabs flex">
          <p
            v-for="item in tabs"
            :key="item.id"
            :class="item.id == cur ? 'active_tabs' : ''"
            @click="tabsCutFg(item)"
          >{{item.name}}</p>
        </div>
      </van-sticky>
      <van-list
        class="goods_top"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="goods_content"
          v-for="item in goodsList"
          :key="item.id"
          @click="goBannerDetails({...item, goods_id: item.id, page_type: 'goods_detail'})"
        >
          <img :src="item.images" alt />
          <p class="goods_title">{{item.goods_name}}</p>
          <div class="price">
            <span class="goods_price">{{item.price}}</span>
            <!-- <span class="price_opti">9</span> -->
          </div>
          <div class="flex">
            <p class="text_price">¥{{item.market_price}}</p>
            <p class="goods_num">{{item.sales}}件已售</p>
          </div>
          <img
            class="suit_img"
            :src="imgPath + 'yj_t_taocan1.png'"
            alt
            v-if="item.is_package_goods == 1 && item.goods_activity_batch_details_id == ''"
          />
          <img
            class="suit_img"
            :src="imgPath + 'yj_t_taoca.png'"
            alt
            v-if="item.is_mz_goods == 1 && item.goods_activity_batch_details_id == ''"
          />
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        { name: '综合推荐', id: 0 },
        { name: '销量', id: 1, type: 'sales' },
        { name: '价格', id: 2, type: 'price' },
      ],
      list: [],
      loading: false,
      finished: false,
      cur: 0,
      page: 0,
      goodsList: [],
      searchName: '',
      order: {},
      serial: 0,
      isGoodsList: true,
    }
  },
  created() {
    // decodeURIComponent
    console.log(this.$route.query.id, this.$route.query.name, '-----')
    if (this.$route.query.name) {
      this.searchName = this.$route.query.name
    }
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    searchInputConHandler() {
      var keycode = event.keyCode
      if (keycode == '13') {
        console.log('111')
        event.preventDefault()
        this.searchFg()
      }
    },
    onLoad() {
      this.page++
      this.getGoodsList()
    },
    // ClientGoods.goodsListByBrandTypeId
    // brandtype_id
    getGoodsList() {
      let url =
        this.$route.query.id && this.$route.query.id != ''
          ? 'ClientGoods.goodsListByBrandTypeId'
          : 'ClientGoods.simpleGoodsList'
      this.http(url, {
        page: this.page,
        limit: 20,
        keywords: this.searchName,
        brandtype_id: this.$route.query.id,
        order: this.order,
      }).then((res) => {
        if (this.isGoodsList) {
          this.goodsList = res.content.list
        } else {
          this.goodsList = this.goodsList.concat(res.content.list)
        }
        this.isGoodsList = false
        this.loading = false
        this.finished = this.goodsList.length == res.content.count
      })
    },
    tabsCutFg(e) {
      this.cur = e.id
      this.order = {}
      this.page = 0
      this.serial = !this.serial
      this.order[e.type] = this.serial == 0 ? 'asc' : 'desc'
      this.isGoodsList = true
      this.onLoad()
    },
    //跳转商品详情
    goBannerDetails(item) {
      console.log(item)
      // if (item.goods_activity_batch_details_id) {
      //   this.goActDetails(item.goods_activity_batch_details_id)
      // } else if (item.page_type == 'goods_detail') {
      //   this.$router.push({
      //     path: '/shopDetails',
      //     query: { goods_id: item.goods_id },
      //   })
      // } else {
      //   window.location.href = item.url
      // }
      if (
        item.goods_activity_batch_details_id &&
        item.goods_activity_batch_details_id != 0 &&
        item.is_mt_goods != 1
      ) {
        this.goActDetails(item.goods_activity_batch_details_id)
      } else if (item.is_mt_goods == 1 && item.page_type == 'goods_detail') {
        this.$router.push({
          path: '/buyActiveShopdetails',
          query: { goods_id: item.goods_id },
        })
      } else if (item.page_type == 'goods_detail' && item.is_mt_goods != 1) {
        this.$router.push({
          path: '/shopDetails',
          query: { goods_id: item.goods_id },
        })
      } else {
        console.log('111')
        // window.location.href = item.url
        this.$router.push({ path: item.url })
      }
    },
    // 特价商品详情
    goActDetails(id) {
      console.log(id)
      this.$router.push({
        path: '/activeShopDetail',
        query: { goods_id: id, isActGoods: 'isAct' },
      })
    },
    searchFg() {
      this.page = 1
      this.goodsList = []
      this.getGoodsList()
    },
  },
}
</script>
<style>
.class_fly .van-list__finished-text {
  width: 100%;
}

.class_fly .van-list__placeholder {
  width: 100%;
}
.class_fly .van-list__loading {
  width: 100%;
}
</style>
<style lang="scss" scoped>
.class_fly {
  background: #f2f3f5;
}
.top_index {
  padding: 0 20px;
  .heigth {
    height: 16px;
  }
  .search {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background: rgba(255, 255, 255, 1);
    border-radius: 37px;
    padding: 14px 8px 14px 32px;
    box-sizing: border-box;
    input {
      padding: 0 10px;
      flex: 1;
    }
    a {
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
      background: linear-gradient(270deg, #ee0a24 0%, #ff5a5a 100%);
      border-radius: 29px;
      padding: 16px 32px;
    }
  }
  .swipe {
    height: 340px;
    border-radius: 20px;
    margin-top: 20px;
  }
}
.goods_list {
  padding: 0 20px;
  margin-top: 20px;
  .tabs {
    padding: 15px 40px;
    background: rgba(242, 243, 245, 1);
    p {
      font-size: 28px;
      color: #333333;
      margin-right: 64px;
    }
  }
  .goods_top {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 40px;
    width: 100%;
  }
  .goods_content {
    position: relative;
    width: 345px;
    background: #ffffff;
    box-shadow: 0px 0px 9px 7px rgba(0, 0, 0, 0.02);
    border-radius: 18px;
    box-sizing: border-box;
    padding: 18px;
    margin-bottom: 20px;
    img {
      width: 309px;
      height: 296px;
    }
    .goods_title {
      height: 70px;
      font-size: 26px;
      color: #000000;
      margin-top: 24px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .price {
      margin-top: 20px;
      .goods_price {
        font-size: 30px;
        color: #f6312a;
      }
      .price_opti {
        font-size: 30px;
        color: rgba(246, 49, 42, 0.3);
      }
    }
    .flex {
      margin-top: 16px;
      justify-content: space-between;
      .text_price {
        font-size: 22px;
        color: #a1a1a1;
        text-decoration: line-through;
      }
      .goods_num {
        font-size: 22px;
        color: #000000;
      }
    }
  }
}
.active_tabs {
  position: relative;
  font-size: 34px !important;
  font-weight: 700;
  color: #333333;
}
.active_tabs::after {
  content: '';
  position: absolute;
  width: 57px;
  bottom: -10px;
  left: 50%;
  transform: translate(-50%);
  height: 21px;
  display: block;
  background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/icon_xa.png')
    no-repeat center;
  background-size: 57px 21px;
}
.suit_img {
  position: absolute;
  top: 0;
  right: 0;
  width: 68px !important;
  height: 50px !important;
}
</style>